import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;
  align-items: start;
  min-width: 45%;
`

export const Name = styled.span`
  text-align: start;
  font-weight: 600;
`
